import { useEffect, useState } from "react";
import useLogin from "../../hooks/useLogin";
import ArrowGoBack from "../ArrowGoBack/ArrowGoBack";
import BoardHeaderMobilePublic from "../Headers/BoardHeaderMobilePublic";
import BoardHeaderPublic from "../Headers/BoardHeaderPublic";
import Footer from "../Footer/Footer";
import styles from "./index.module.css";

const DocLayout = ({ children, callbackUrl }) => {
  const { confirmIsAuth } = useLogin();
  const [authStatus, setAuthStatus] = useState("checking"); // "checking", "authorized", "unauthorized"
  const mediaQuery = window.matchMedia("(max-width: 427px)");

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const isAuth = await confirmIsAuth();
        setAuthStatus(isAuth ? "authorized" : "unauthorized");
      } catch (error) {
        setAuthStatus("unauthorized");
      }
    };
    checkAuth();
  }, []);

  return (
    <div className={`general-content`}>
      <div className={styles.content}>
        <div className="B-H">
          {!mediaQuery.matches ? (
            <BoardHeaderPublic />
          ) : (
            <BoardHeaderMobilePublic />
          )}
        </div>
        <div className={styles.center}>
          <ArrowGoBack forcedPrev={[callbackUrl]} />
          <div className={styles.children}>{children}</div>
        </div>
      </div>

      {!mediaQuery.matches ? (
        <div className="con-foo">
          <Footer classN="fooInDash" />
        </div>
      ) : null}
    </div>
  );
};

export default DocLayout;
